import type { GiftPattern } from './domain';

export const ageBands = ['10s', '20s', '30s', '40s', '50s', '60plus'] as const;
export type AgeBand = typeof ageBands[number];
export const ageLabels:Record<AgeBand,string>={'10s':'10대','20s':'20대','30s':'30대','40s':'40대','50s':'50대','60plus':'60대 이상'};

const relevance: Record<AgeBand, readonly string[]> = {
  '10s': ['choice', 'books', 'fitness', 'craft'],
  '20s': ['experience', 'choice', 'movie', 'craft'],
  '30s': ['experience', 'time', 'books', 'practical'],
  '40s': ['time', 'experience', 'food', 'practical'],
  '50s': ['care', 'food', 'family', 'time'],
  '60plus': ['care', 'food', 'family', 'time'],
};

/** 명시적으로 적은 연령대만 해석하며, 사람의 성별·건강은 추정하지 않는다. */
export function parseAgeBand(text: string): AgeBand | undefined {
  const matches = [...text.matchAll(/(?<!\d)(10|20|30|40|50|60|70|80|90)\s*대(?!\d)/g)];
  const bands = new Set(matches.map((match): AgeBand => ({'10':'10s','20':'20s','30':'30s','40':'40s','50':'50s'} as Record<string,AgeBand>)[match[1]] ?? '60plus'));
  return bands.size === 1 ? [...bands][0] : undefined;
}

/** 기존 금기·예산 필터를 통과한 후보에서만 추가하는 약한 신호. */
export function ageAdjustment(pattern: GiftPattern, ageBand?: AgeBand): number {
  if (!ageBand) return 0;
  const tags = new Set([...pattern.tags, pattern.category]);
  return Math.min(24, relevance[ageBand].filter(tag => tags.has(tag)).length * 12);
}
export function ageReason(pattern: GiftPattern, ageBand?: AgeBand): string | undefined {
  return ageAdjustment(pattern, ageBand) ? '선택한 연령대에 맞춰 관련 범주를 함께 살폈어요.' : undefined;
}
